import { Moon, Palette, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ACCENT_LABELS, ACCENT_SWATCHES, type ThemeAccent, useTheme } from './theme-provider';

export function ThemeModeToggle() {
  const { mode, toggleMode } = useTheme();
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleMode}
      title={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {mode === 'dark' ? <Sun className="size-4" /> : <Moon className="size-4" />}
    </Button>
  );
}

export function ThemeAccentPicker() {
  const { accent, setAccent } = useTheme();
  const accents = Object.keys(ACCENT_LABELS) as ThemeAccent[];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" title="Pick accent color">
          <Palette className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        <DropdownMenuLabel>Accent color</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {accents.map((a) => (
          <DropdownMenuItem
            key={a}
            onClick={() => setAccent(a)}
            className="flex items-center gap-2"
          >
            <span
              className="size-4 rounded-full border border-border"
              style={{ background: ACCENT_SWATCHES[a] }}
            />
            <span className="flex-1">{ACCENT_LABELS[a]}</span>
            {accent === a && <span className="text-xs text-muted-foreground">✓</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
